<!-- src/components/layout/Notifications.vue -->
<template>
    <div class="notifications-container">
      <div 
        v-for="notification in notifications" 
        :key="notification.id"
        class="toast show"
        :class="`bg-${notification.type} text-white`"
        role="alert" 
        aria-live="assertive" 
        aria-atomic="true"
      >
        <div class="toast-header" :class="`bg-${notification.type} text-white`">
          <i class="bi" :class="getIconClass(notification.type)"></i>
          <strong class="me-auto ms-2">{{ getTitle(notification.type) }}</strong>
          <button 
            type="button" 
            class="btn-close btn-close-white"
            @click="dismiss(notification.id)"
            aria-label="Close"
          ></button>
        </div>
        <div class="toast-body">
          {{ notification.message }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  
  export default {
    name: 'Notifications',
    computed: {
      ...mapState({
        notifications: state => state.notifications
      })
    },
    methods: {
      dismiss(id) {
        this.$store.commit('REMOVE_NOTIFICATION', id);
      },
      getIconClass(type) {
        const icons = {
          success: 'bi-check-circle-fill',
          danger: 'bi-exclamation-triangle-fill',
          warning: 'bi-exclamation-circle-fill',
          info: 'bi-info-circle-fill'
        };
        return icons[type] || 'bi-bell-fill';
      },
      getTitle(type) {
        const titles = {
          success: 'Éxito',
          danger: 'Error',
          warning: 'Advertencia',
          info: 'Información'
        };
        return titles[type] || 'Notificación';
      }
    }
  };
  </script>
  
  <style scoped>
  .notifications-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1050;
    max-width: 350px;
  }
  
  .toast {
    margin-bottom: 10px;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
    opacity: 0.95;
  }
  
  .toast:hover {
    opacity: 1;
  }
  </style>